export default __webpack_public_path__ + "static/media/promotion_blank.38729be6.png";